import { render } from "./Modal.vue?vue&type=template&id=f2372a7a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=f2372a7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f2372a7a"

export default script